import React from "react";
import { Link } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  NavItem,
  NavLink
} from "shards-react";

export default class LogoActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.toggleUserActions = this.toggleUserActions.bind(this);
  }

  toggleUserActions() {
    this.setState({
      visible: !this.state.visible
    });
  }

  render() {
    return (
      <NavItem tag={Dropdown} caret toggle={this.toggleUserActions}>
        <DropdownToggle caret tag={NavLink} className="text-nowrap px-3">
          <img
            className="rounded-circle"
            src={require("./../../../images/others/logo.jpg")}
            style={{ width: "60px" }}
            alt="User Avatar"
          />
          <span className="d-none d-md-inline-block">Matriz Criativa</span>
        </DropdownToggle>
        <Collapse tag={DropdownMenu} right small open={this.state.visible}>
          <DropdownItem tag={Link} to="/">
            <i className="material-icons">home</i> Home
          </DropdownItem>
          {/* <DropdownItem tag={Link} to="/">
            <i className="material-icons">contact_phone</i> Contato
          </DropdownItem>
          <DropdownItem tag={Link} to="/">
            <i className="material-icons">contact_support</i> Sobre nós
          </DropdownItem> */}
          <DropdownItem tag={Link} to="/map-page">
            <i className="material-icons">how_to_reg</i> Sonhos
          </DropdownItem>
        </Collapse>
      </NavItem>
    );
  }
}
